import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/peugeot-second-hand-romania/")({
  head: () => routeHead("/peugeot-second-hand-romania/"),
  beforeLoad: () => {
    throw redirect({ href: "/cars/peugeot", statusCode: 301, replace: true });
  },
});
